var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.66667L5.84437 6.89627C6.98484 7.65653 7.55511 8.03671 8.17138 8.18444C8.71609 8.31493 9.28391 8.31493 9.82862 8.18444C10.4449 8.03671 11.0152 7.65653 12.1556 6.89627L17 3.66667M3.84444 13.4444H14.1556C15.1512 13.4444 15.6491 13.4444 16.0293 13.2507C16.3638 13.0803 16.6358 12.8083 16.8062 12.4738C17 12.0935 17 11.5956 17 10.6V3.84444C17 2.8488 17 2.35097 16.8062 1.97068C16.6358 1.63617 16.3638 1.3642 16.0293 1.19377C15.6491 1 15.1512 1 14.1556 1H3.84444C2.8488 1 2.35097 1 1.97068 1.19377C1.63617 1.3642 1.3642 1.63617 1.19377 1.97068C1 2.35097 1 2.84879 1 3.84444V10.6C1 11.5956 1 12.0935 1.19377 12.4738C1.3642 12.8083 1.63617 13.0803 1.97068 13.2507C2.35097 13.4444 2.84879 13.4444 3.84444 13.4444Z",
    stroke: "#384F9F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.a66d79ade190a39a719f6d41999ae791.svg";
export { ForwardRef as ReactComponent };